//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { cloneDeep } from 'lodash';
import { PLATFORMS } from '@/utils/constant';
import { mapGetters } from 'vuex';
export default {
  props: {
    searchObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    permissionMap: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      platform: 2,
      PLATFORMS,
      menuData: [],
      columns: [
        {
          colKey: 'name',
          title: '名称',
          minWidth: 140,
        },
        {
          colKey: 'code',
          title: 'Code',
          minWidth: 140,
        },
        {
          colKey: 'path',
          title: '路径',
          minWidth: 140,
        },
        {
          colKey: 'order_weight',
          title: '权重',
          minWidth: 140,
        },
        {
          colKey: 'display',
          title: '展示状态',
          minWidth: 140,
        },
        {
          colKey: 'description',
          title: '描述',
          minWidth: 140,
        },
        {
          colKey: 'permission',
          title: '权限',
          minWidth: 140,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        roleManage: this.getElementList.includes('role-manage'),
      };
    },
  },
  methods: {
    init() {
      this.loadMenuData();
    },
    loadMenuData() {
      const url = this.$api.getMenuBaseTree;
      const cb = (data) => {
        this.initPermission(data.data);
        this.menuData = data.data;
        this.$nextTick(() => {
          this.$refs.tTable.expandAll();
        });
      };
      return this.$request({
        url,
        cb,
        data: { appid: this.searchObj.appid, platform: this.platform },
        //  搜索
      });
    },
    changePlatform() {
      sessionStorage.setItem('platform', this.platform);
      this.$router.push({
        query: {
          ...this.$route.query,
          platform: this.platform,
        },
      });
      this.loadMenuData();
    },
    initPermission(list) {
      for (const item of list) {
        if (
          !this.permissionMap[item.permission_id] ||
          this.permissionMap[item.permission_id]?.length == 0
        ) {
          this.$set(this.permissionMap, item.permission_id, []);
        }

        if (item.children && item.children.length > 0) {
          this.initPermission(item.children);
        }
        if (item.fields && item.fields?.length > 0) {
          this.initPermission(item.fields);
        }
      }
    },
    permissionChange(data, action, value) {
      console.log(value);
      let url = '';
      if (value === true) {
        url = this.$api.addRolePermission;
      } else {
        url = this.$api.removeRolePermission;
      }

      const cb = (res) => {
        console.log('权限设置成功 :>> ', res);
      };
      this.$request({
        url,
        cb,
        data: {
          role_id: this.searchObj.role_id,
          permission_id: data.permission_id,
          action,
        },
      });
    },
  },
};
